'use strict';

const jQuery = require('jquery');

const Container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');
const FormBuilder = require('./../../builder');
const ElementClass = require('./../../elementClass');

const Uploader = require('./../../../../bundles/content/service/uploader');
const Dropzone = require('./../../../../bundles/content/service/dropzone');
const UploadPlugin = require('./../../../../bundles/content/plugin/upload');

const formatBytes = require('./../../../../bundles/content/service/formatBytes');

const previewTpl = require('./template/preview.hbs');
const dropzoneTpl = require('./template/dropzone.hbs');

const imgExt = ['jpg', 'jpeg', 'png', 'svg', 'gif'];

FormBuilder.register('upload', function(config) {
  let self = new ElementClass(config);
  let value = config.value || '';
  let $wrapper;
  let path = value;

  const onUpload = function(file) {
    let uploadConfig = {
      forceResizeImage: config.forceResizeImage,
      afterUpload: config.afterUpload,
    };

    Uploader.upload(file, uploadConfig).done((uploadData) => {
      buildPreview(config.useUrl ? uploadData.url : uploadData.path);

      if (typeof config.form.afterPictoUpload === 'function') {
        config.form.afterPictoUpload();
      }
    });
  };

  const buildPreview = function(currentPath) {
    const fileType = currentPath.split('.').pop();
    let $preview = jQuery(previewTpl());

    $preview.find('.btn-remove').on('click', function() {
      path = '';
      createDropzone();

      if (typeof config.form.afterRemove === 'function') {
        config.form.afterRemove();
      }
    });

    if (-1 !== imgExt.indexOf(fileType)) {
      let imageUrl = config.notModifyUrl ? currentPath : Container.get('getResourceUrl')(currentPath);
      $preview.append('<img src="' + imageUrl + '">');
    } else {
      $preview.append(`<p>${currentPath}</p>`);
    }

    path = currentPath;

    $wrapper.append($preview).find('.cloud-dropzone').remove();
  };

  const createDropzone = function() {
    let $dropzone;

    let acceptedFiles = config.acceptedFiles || '';

    if (acceptedFiles.includes('image') && config.forceLocal !== true) {
      let maxSize = formatBytes.format(Container.get('$toolbar').data('maxSize'));
      let label = config.label || 'drop_image_file';
      let icon = config.icon || 'icon-new-post';

      $dropzone = jQuery(dropzoneTpl({
        label,
        icon,
        'label_size': Translator.translate('drop_image_size', {'size': maxSize}),
      }));

      $dropzone.on('click', function() {
        UploadPlugin.createMediaPopin({
          isImage: true,
          onChange: (file) => {
            return new Promise((resolve) => {
              onUpload(file);
              resolve();
            });
          },
          onMediaClick: (resource) => {
            return new Promise((resolve) => {
              buildPreview(resource.path);
              resolve();
            });
          },
        });
      });
    } else {
      $dropzone = Dropzone.create({
        'onChange': onUpload,
        'accepted_files': config.acceptedFiles,
      });
    }

    $wrapper.append($dropzone).find('.cloud-preview').remove();

    return $dropzone;
  };

  self.render = function() {
    $wrapper = jQuery('<div class="cloud-upload"></div>');

    if (config.description) {
      $wrapper.append(jQuery(`<p>${Translator.translate(config.description)}</p>`));
    }

    value ? buildPreview(value) : createDropzone();

    return $wrapper;
  };

  self.getData = function() {
    return path || '';
  };

  return self;
});
